import { createSelector } from 'reselect';
import moment from 'moment';

import { permissions } from './user';

const checkIsAllowed = (event, permissions, func = () => true) => {
  return event.game.every(game =>
    permissions.find(
      permission => permission.game === game && func(permission),
    ),
  );
};

export const baseEvent = state => state.event.event;
export const event = createSelector(
  baseEvent,
  permissions,
  (event, permissions) => {
    if (!event) {
      return null;
    }

    const isReadable = checkIsAllowed(event, permissions);
    const isWritable = checkIsAllowed(
      event,
      permissions,
      ({ operation }) => operation === 'write',
    );

    return {
      ...event,
      ...event.payload,
      resolutionDate: moment(event.payload.resolutionDate),
      dateTime: moment(event.dateTime),
      isReadable,
      isWritable,
    };
  },
);
